import Styles from './PublishDrawer.module.scss'
import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'
import { Heading } from 'blaze-ui/Heading/Heading'
import { track } from '@tldraw/tldraw'
import { ChevronLeft } from 'blaze-ui/icons/24'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { useRootStore } from 'stores/RootStore'
import { useIsChannelPostable } from 'components/PostStatusDropdown/utils'
import { MobileSchedulingOptions } from './MobileSchedulingOptions'
import { DesignChannel } from 'components/NewFileModal/Types'
import { ExportButtons } from './components/ExportButtons'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { ScheduledPostStatusTag } from 'components/ScheduledPostStatusTag/ScheduledPostStatusTag'

export const PublishDrawer = track(
  observer((props: DrawerProps) => {
    const editor = useEditor()
    const { designStore } = useRootStore()
    const file = designStore?.file
    const { isChannelSocialPostable } = useIsChannelPostable()
    const isPostPreviewV2 = useFlipperFlag('post_preview_v2_mobile')
    const channel = file?.channel || undefined

    if (!editor || !file) return null

    const scheduledPostId = file.scheduled_post_id
    const isPostable = isChannelSocialPostable(channel)

    if (isPostPreviewV2) {
      return (
        <Drawer.Root {...props}>
          <Drawer.Portal>
            <Drawer.Content onOpenAutoFocus={(e) => e.preventDefault()}>
              <Drawer.InnerContent>
                <Drawer.Top>
                  <div className={Styles.scheduledPostStatus}>
                    <ScheduledPostStatusTag scheduledPostId={scheduledPostId} articleId={file.id} />
                  </div>
                  <Drawer.Title asChild>
                    <Heading level={5}>Publish</Heading>
                  </Drawer.Title>
                  <Drawer.Close label="Close" variant="ghost" position="right" />
                </Drawer.Top>
                <Drawer.Container>
                  <div className={Styles.body}>
                    {isPostable && scheduledPostId && channel && (
                      <div>
                        <MobileSchedulingOptions
                          fileId={file.id}
                          scheduledPostId={scheduledPostId}
                          channel={channel as DesignChannel}
                        />
                      </div>
                    )}
                  </div>
                </Drawer.Container>
              </Drawer.InnerContent>
            </Drawer.Content>
          </Drawer.Portal>
        </Drawer.Root>
      )
    }

    return (
      <Drawer.Root {...props}>
        <Drawer.Portal>
          <Drawer.Content fullHeight onOpenAutoFocus={(e) => e.preventDefault()}>
            <Drawer.InnerContent isSnappedTop>
              <Drawer.Top>
                <Drawer.Close icon={ChevronLeft} label="" />
                <Drawer.Title asChild>
                  <Heading level={5}>Publish</Heading>
                </Drawer.Title>
              </Drawer.Top>
              <Drawer.Container>
                <div className={Styles.body}>
                  <ExportButtons />
                  {isPostable && scheduledPostId && channel && (
                    <div>
                      <MobileSchedulingOptions
                        fileId={file.id}
                        scheduledPostId={scheduledPostId}
                        channel={channel as DesignChannel}
                      />
                    </div>
                  )}
                </div>
              </Drawer.Container>
            </Drawer.InnerContent>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    )
  }),
)
